<template>
  <div>
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <div class="ba_f pad_lr_20">
        <div class="shuju_title mar_b20">
          <div class="shuju_title_text">
            <span>{{ $t('rider.health.title') }}</span>
          </div>
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline searchform">
          <div class="flex mar_t20 mar_b20">
            <el-form-item :label="$t('common.status')">
              <el-select v-model="formInline.state" :placeholder="$t('common.pleaseSelect')" @change="onSearch">
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('rider.list.name')" class="mar_l20">
              <el-input
                v-model="formInline.name"
                size="medium"
                :placeholder="$t('rider.health.namePh')"
                @input="onSearch"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch" size="medium">{{ $t('common.filter') }}</el-button>
              <el-button type="primary" @click="handleOperate('', 'adopt')" size="medium">{{ $t('common.batchPass') }}</el-button>
              <el-button type="primary" @click="handleOperate('', 'reject')" size="medium">{{ $t('common.batchReject') }}</el-button>
              <el-button type="primary" @click="handleOperate('', 'delete')" size="medium">{{ $t('common.batchDelete') }}</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="ba_f mar_t20 pad_20">
        <el-table
          v-loading="listLoading"
          :element-loading-text="loadingText"
          :data="list"
          stripe
          style="width: 100%"
          @selection-change="setSelectRows"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="userName" :label="$t('rider.list.name')"></el-table-column>
          <el-table-column prop="frontImg" :label="$t('rider.health.frontImg')">
            <template slot-scope="scope">
              <div class="imgbox">
                <img :src="scope.row.icon" class="tabimg" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" :label="$t('rider.health.submitTime')"></el-table-column>
          <el-table-column prop="state" :label="$t('rider.health.auditStatus')">
            <template slot-scope="scope">
              <div v-if="scope.row.state == 1">{{ $t('rider.health.pending') }}</div>
              <div v-if="scope.row.state == 2">{{ $t('rider.health.approved') }}</div>
              <div v-if="scope.row.state == 3">{{ $t('rider.health.rejected') }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.operation')">
            <template slot-scope="scope">
              <div class="flex">
                <el-button
                  type="text"
                  v-if="scope.row.state == '1'"
                  @click="handleOperate(scope.row, 'adopt')"
                >{{ $t('common.pass') }}</el-button>
                <el-button
                  type="text"
                  v-if="scope.row.state == '1'"
                  @click="handleOperate(scope.row, 'reject')"
                >{{ $t('common.reject') }}</el-button>
                <el-button type="text" @click="handleSeeEdit(scope.row)">{{ $t('common.edit') }}</el-button>
                <el-button type="text" @click="handleOperate(scope.row, 'delete')">{{ $t('common.delete') }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="page.total"
          :page-size="page.pagesize"
          :current-page.sync="page.currentPage"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :title="$t('common.edit')"
      :visible.sync="dialogVisible"
      width="800px"
      :close-on-click-modal="false"
      @close="close"
    >
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item :label="$t('common.realName')" prop="company" :required="true">
          <el-input v-model.trim="form.company" autocomplete="off" :placeholder="$t('rider.health.namePh')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('rider.health.frontPhoto')" prop="icon" :required="true">
          <div class="uploadSource bor_de rel flex" v-if="form.icon">
            <label class="statusLabel curs" @mouseenter="enter(1)" @mouseleave="leave(1)">
              <i class="el-icon-check" ref="imgicon1"></i>
              <i class="el-icon-close" @click="deleteMultiImage(form.icon, 1)"></i>
            </label>
            <img :src="form.icon" @click="test(1)" class="wid" />
          </div>
          <div class="uploadSource flex-center curs" v-else @click="test(1)">
            <i class="el-icon-plus fon_40 color_d9"></i>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="close">{{ $t('common.cancel') }}</el-button>
        <el-button size="medium" type="primary" @click="save">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
    <attachment-img ref="img1" type="img" @attachment="imgadd1"></attachment-img>
  </div>
</template>
<script>
import attachmentImg from "@/plugins/attachment-img";
import {
  health_toExamine,
  healthInfo,
  updateHealthAttestation,
  healthAuthentication,
} from "@/api/rider";

export default {
  data() {
    return {
      formInline: {
        state: "",
        name: "",
        tel: "",
      },
      form: {
        company: "",
        icon: "",
        id: "",
      },
      value: "",
      list: [],
      listLoading: true,
      selectRows: "",
      dialogVisible: false,
      page: {
        total: 0,
        size: 10,
        currentPage: 1,
      },
    };
  },
  components: { attachmentImg },
  created() {
    this.fetchData();
  },
  computed: {
    loadingText() {
      return this.$t('common.loading');
    },
    statusOptions() {
      return [
        { value: "0", label: this.$t('common.all') },
        { value: "1", label: this.$t('rider.health.pending') },
        { value: "2", label: this.$t('rider.health.approved') },
        { value: "3", label: this.$t('rider.health.rejected') },
      ];
    },
  },
  methods: {
    setSelectRows(val) {
      this.selectRows = val;
    },
    onSearch() {
      this.fetchData();
    },
    handleSeeEdit(row) {
      this.dialogVisible = true;
      this.attestationInfo(row.id);
    },
    handleOperate(row, type) {
      let text = "";
      switch (type) {
        case "adopt":
          text = this.$t('common.pass');
          break;
        case "reject":
          text = this.$t('common.reject');
          break;
        case "delete":
          text = this.$t('common.delete');
          break;
      }
      if (row.id) {
        this.$baseConfirm(this.$t('confirm.actionItem', { action: text }), null, async () => {
          const { msg } = await healthAuthentication({
            id: [row.id],
            type: type,
          });
          this.$baseMessage(msg, "success");
          this.fetchData();
        });
      } else {
        if (this.selectRows.length > 0) {
          const id = this.selectRows.map((item) => item.id);
          this.$baseConfirm(this.$t('confirm.actionSelected', { action: text }), null, async () => {
            const { msg } = await healthAuthentication({ id: id, type: type });
            this.$baseMessage(msg, "success");
            this.fetchData();
          });
        } else {
          this.$baseMessage(this.$t('common.noRowSelected'), 'error');
          return false;
        }
      }
    },
    async attestationInfo(id) {
      const { data } = await healthInfo({ id: id });
      this.form = Object.assign(this.form, data);
    },
    close() {
      this.$refs["form"].resetFields();
      this.form = this.$options.data().form;
      this.dialogVisible = false;
    },
    save() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const { msg } = await updateHealthAttestation(this.form);
          this.$baseMessage(msg, "success");
          this.fetchData();
          this.close();
        } else {
          return false;
        }
      });
    },
    async fetchData() {
      var params = {
        page: this.page.currentPage,
      };
      if (this.formInline.name) {
        params.name = this.formInline.name;
      }
      if (this.formInline.tel) {
        params.tel = this.formInline.tel;
      }
      if (this.formInline.state) {
        params.state = this.formInline.state;
      }
      const { data, count } = await health_toExamine(params);
      this.list = data;
      this.page.total = count;
      this.listLoading = false;
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.fetchData();
    },
    enter(i = 0) {
      this.$refs["imgicon" + i].style.display = "none";
    },
    leave(i = 0) {
      this.$refs["imgicon" + i].style.display = "inline-block";
    },
    test(i = 0) {
      this.$refs["img" + i].dialogVisible = true;
    },
    imgadd1(url) {
      this.form.icon = url.str;
    },
    deleteMultiImage(item, index, type) {
      Array.prototype.remove = function (val) {
        var index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      if (!type) {
        switch (index) {
          case 1:
            this.form.frontImg = "";
            break;
          case 2:
            this.form.backImg = "";
            break;
        }
      }
    },
  },
};
</script>
